(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initProductScrollTracks() {
    document.querySelectorAll('#main [id$="__featured-collections"] scroll-carousel').forEach(carousel => {
      const track = carousel.nextElementSibling;
      if (!track?.classList.contains('kb-product-scroll-track') || track.dataset.bound) return;
      track.dataset.bound = 'true';
      const thumb = track.firstElementChild;
      const update = () => {
        const total = carousel.scrollWidth;
        const viewport = carousel.clientWidth;
        if (!total) return;
        track.hidden = total <= viewport + 1;
        thumb.style.width = Math.max(10,viewport / total * 100) + '%';
        thumb.style.left = Math.max(0,carousel.scrollLeft / total * 100) + '%';
      };
      carousel.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(carousel);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initProductScrollTracks);
  else initProductScrollTracks();
  document.addEventListener('shopify:section:load',initProductScrollTracks);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kerabox-petals"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setupPetals() {
    const overlay = document.querySelector('[data-kb-petals]');
    if (!overlay || overlay.dataset.initialized) return;
    overlay.dataset.initialized = 'true';
    document.body.append(overlay);
    overlay.hidden = false;
    let manualPause = false;
    const button = overlay.querySelector('button');
    const update = () => overlay.classList.toggle('is-paused', manualPause || document.hidden);
    button.addEventListener('click', () => {
      manualPause = !manualPause;
      button.setAttribute('aria-pressed', String(manualPause));
      button.setAttribute('aria-label', manualPause ? 'Start dekorativ animasjon' : 'Pause dekorativ animasjon');
      button.innerHTML = manualPause ? '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true"><path d="M7 5l8 5-8 5Z" fill="currentColor"/></svg>' : '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true"><path d="M7 5v10M13 5v10" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
      update();
    });
    document.addEventListener('visibilitychange', update);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupPetals);
  else setupPetals();
  document.addEventListener('shopify:section:load', setupPetals);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kerabox-price-request"] && !Shopify.designMode) return;
  try {
    
function keraboxSetProductContext() {
  const product = new URLSearchParams(window.location.search).get('produkt');
  if (!product || !product.trim() || product.length > 300) return;
  document.querySelectorAll('[data-kb-product-context]').forEach((context) => {
    const input = context.querySelector('input');
    if (!input) return;
    input.value = product.trim();
    input.disabled = false;
    context.hidden = false;
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', keraboxSetProductContext);
else keraboxSetProductContext();
document.addEventListener('shopify:section:load', keraboxSetProductContext);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kerabox-salon-contact"] && !Shopify.designMode) return;
  try {
    
function keraboxSetProductContext() {
  const product = new URLSearchParams(window.location.search).get('produkt');
  if (!product || !product.trim() || product.length > 300) return;
  document.querySelectorAll('[data-kb-product-context]').forEach((context) => {
    const input = context.querySelector('input');
    if (!input) return;
    input.value = product.trim();
    input.disabled = false;
    context.hidden = false;
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', keraboxSetProductContext);
else keraboxSetProductContext();
document.addEventListener('shopify:section:load', keraboxSetProductContext);

  } catch(e) { console.error(e); }
})();
})();
